import { handleActions } from 'redux-actions';
import {
    fetchTopUsdPriceRequest,
    fetchTopUsdPriceSuccess,
    fetchTopUsdPriceError,
} from '../actions/FetchCoinList';

const defaultState = {
  data: [],
  isFetching: false,
  error: null,
};

export default handleActions(
  {
    [fetchTopUsdPriceRequest](state) {
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    },
    [fetchTopUsdPriceSuccess](state, { payload }) {
      return {
        ...state,
        data: payload,
        isFetching: false,
        error: null,
      };
    },
    [fetchTopUsdPriceError](state, { payload }) {
      return {
        ...state,
        isFetching: false,
        error: payload,
      };
    },
  },
  defaultState,
);
